// extracted by mini-css-extract-plugin
export default {"projectOverview":"ProjectOverview-module__projectOverview___TkE6X","disabled":"ProjectOverview-module__disabled___Sp_xN"};